<div class="patron-component">
  <div class="text-center font-medium border-bottom-1 mb-3">Entrar</div>

  @if (blockedMessage) {
    <patron-alert color="danger" class="auth__blocked">
      <strong>Acesso indisponível.</strong> {{ blockedMessage }}
    </patron-alert>
  }
  @if (!user) {
    <div>
      <patron-form [formGroup]="authForm" (onSubmit)="onSubmit()">
        <div style="height: 100px">
          <patron-form-field [formGroup]="authForm" formControlName="email" label="Email">
          </patron-form-field>
        </div>
        <div style="height: 100px">
          <patron-form-field
            [formGroup]="authForm"
            formControlName="password"
            label="Senha"
            type="password">
          </patron-form-field>
        </div>
        <div class="container p-0 mt-2">
          <div class="row">
            <patron-button
              type="submit"
              [loading]="loading"
              customStyle="width: 100%"
              customClass="login-button flex justify-content-center"
              class="w-full"
              iconName="bi-box-arrow-in-right">
              Entrar
            </patron-button>
            @if (config.firebaseProjectId) {
              <div>
                <patron-divider align="center">
                  <small class="font-medium">OU</small>
                </patron-divider>
                <patron-button
                  iconName="bi-google"
                  (click)="googleLogin()"
                  color="danger"
                  [loading]="loadingGoogle"
                  customStyle="width: 100%"
                  customClass="d-flex justify-content-center">
                  Entrar com Google
                </patron-button>
              </div>
            }
          </div>
        </div>
        <div class="text-center mt-4">
          <small>
            <a href="javascript:void(0)" (click)="goToResetPassword()">Esqueceu a senha?</a>
          </small>
        </div>
      </patron-form>
    </div>
  }

  @if (user && !currentCompanyGroup) {
    <div>
      <p>Olá, {{ user?.name || user?.login }}!</p>
      <div>
        <p class="mb-3">De que forma deseja acessar?</p>
        @if (companyGroups.length) {
          <patron-select-company (onSubmit)="completeLogin()"></patron-select-company>
        }
      </div>
      <div class="mt-3">
        <patron-button
          (click)="logout()"
          variant="outline"
          color="secondary"
          iconName="bi-box-arrow-left">
          Sair
        </patron-button>
      </div>
    </div>
  }
</div>

@if (loadingGoogle) {
  <patron-overlay [showSpinner]="false"></patron-overlay>
}
